export const PRODUCT = {
  BRANDED_CAMPAIGN: 'BRANDED_CAMPAIGN',
  GENEROSITY_NETWORK: 'GENEROSITY_NETWORK',
  GENEROSITY_NETWORK_CHARITIES: 'GENEROSITY_NETWORK_CHARITIES',
  PP_FUNDRAISING: 'PP_FUNDRAISING',
};

export const INTEGRATION_IDENTIFIER = {
  DIRECT: 'DIRECT',
  PPGF: 'PPGF', // PayPal Giving Fund
};

export const PAYMENT_PRODUCT = {
  PUBLIC_MONEY_POOL: 'PUBLIC_MONEY_POOL',
};
